import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {ToastrService} from 'ngx-toastr';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Ignorer les erreurs gérées localement (comme le 409 de ComplaintStateService)
      if (req.context.get(BYPASS_ERROR_INTERCEPTOR)) {
        return throwError(() => error);
      }

      let errorMessage = 'Une erreur inattendue est survenue. Veuillez réessayer plus tard.';

      if (error.error instanceof ErrorEvent) {
        // Erreur côté client
        errorMessage = `Erreur client : ${error.error.message}`;
      } else {
        // Erreur côté serveur
        switch (error.status) {
          case 400:
            errorMessage = 'Requête invalide. Veuillez vérifier les données envoyées.';
            break;
          case 401:
            errorMessage = 'Vous n\'êtes pas autorisé à effectuer cette action.';
            // On pourrait aussi déclencher une déconnexion ici
            break;
          case 403:
            errorMessage = 'Accès refusé. Vous n\'avez pas les droits nécessaires.';
            break;
          case 404:
            errorMessage = 'La ressource demandée n\'a pas été trouvée.';
            break;
          case 500:
            errorMessage = 'Erreur interne du serveur. Notre équipe a été notifiée.';
            break;
        }
      }

      toastr.error(errorMessage, 'Erreur');

      return throwError(() => error);
    })
  );
};

// Contexte pour contourner l'intercepteur si une erreur est gérée localement
import {HttpContextToken} from '@angular/common/http';
export const BYPASS_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
